export default "__VITE_ASSET__BxxdmuLP__"